import React from 'react';
import { useLanguage } from '../LanguageContext';
import { motion } from 'framer-motion';
export const HowItWorks = () => {
  const {
    t
  } = useLanguage();
  const steps = [{
    num: '01',
    title: t.howItWorks.step1.title,
    desc: t.howItWorks.step1.desc
  }, {
    num: '02',
    title: t.howItWorks.step2.title,
    desc: t.howItWorks.step2.desc
  }, {
    num: '03',
    title: t.howItWorks.step3.title,
    desc: t.howItWorks.step3.desc
  }];
  return <section className="py-24 bg-slate-50" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="text-center mb-16" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900" data-id="element-109">
            {t.howItWorks.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto relative" data-id="element-110">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16.666%] right-[16.666%] h-0.5 bg-indigo-100 -z-0" data-id="element-111"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-112">
              <div className="w-24 h-24 bg-white rounded-full border-4 border-indigo-50 shadow-xl flex items-center justify-center mb-6 text-2xl font-black text-indigo-600" data-id="element-113">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-114">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-115">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};